export default class UserAlert {
  public id: string;
  public message: string;
  public title: string;
  public key: string;
  public path: string;

  constructor(
    id: string,
    message: string,
    title: string,
    key: string,
    path: string,
  ) {
    this.id = id;
    this.message = message;
    this.title = title;
    this.key = key;
    this.path = path;
  }

  public static fromServerAlert(serverAlert: Record<string, any>) {
    return new UserAlert(
      serverAlert['id'],
      serverAlert.alert['message'],
      serverAlert.alert['title'],
      serverAlert.alert['key'],
      serverAlert.alert['path'],
    );
  }
}
